// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "INVOICE",
    ENTITY_NAME: "invoice",
    RESOURCE: "invoices",
};
